import { useState } from "react";
import Variant, { getVariant, Results } from "./Variant";
import userBreakpoint from "../../hooks/user-breakpoint";
import {
  F,
  squareKhit,
  fmtAns,
  getDegreesFromResultAndPrice,
  avg,
  absoluteDifference,
} from "./functions";
import Average from "./Average";
import { useEffect } from "react";

export default function Sqkhit() {
  const [price, setPrice] = useState(0);
  const [degrees, setDegrees] = useState(0);
  const [xresult, setXresult] = useState(0);
  const [result, setResult] = useState({ presult: 0, nresult: 0, Xs: null });
  // break points
  const breakpoint = userBreakpoint();
  const isMobile =
    breakpoint === "xs" || breakpoint === "sm" || breakpoint === "md";

  const over100Variant = getVariant(price, degrees, 1 / 100);
  const over10Variant = getVariant(price, degrees, 1 / 10);
  const by100Variant = getVariant(price, degrees, 100);
  const by10Variant = getVariant(price, degrees, 10);

  useEffect(() => {
    // console.clear()
    // console.log(squareKhit(price, degrees))
    const [presult, nresult, Xs] = squareKhit(price, degrees);
    setResult({ presult, nresult, Xs });
  }, [price, degrees]);

  useEffect(() => {
    console.log({ xresult });
  }, [xresult]);

  const setPriceAndResultFromAvg = ({ p, r }) => {
    setPrice(p);
    setXresult(r);
  };

  const setDegreesFromResultAndPrice = () => {
    if (!xresult || !price) return;
    const xDegrees = F(getDegreesFromResultAndPrice(F(xresult), F(price)));
    console.log({ xresult, price, xDegrees });
    setDegrees(xDegrees);
  };

  const colClass = "col-lg-2 col-md-6 mb-3";

  const overColumns = (
    <>
      <Variant
        {...over100Variant}
        priceLabel="/ 100"
        alertClass="success"
        colClass={colClass}
        presultAvg={avg(over100Variant.presult * 10, over10Variant.presult)}
        nresultAvg={avg(over100Variant.nresult * 10, over10Variant.nresult)}
      />
      {/* <ResultsAlert colCss={colClass} alertClass={"secondary"} first={(10+30)/2} second={(0.68*10+2.98)/2} /> */}
      <Variant
        {...over10Variant}
        priceLabel="/ 10"
        alertClass="primary"
        colClass={colClass}
        presultAvg={avg(over10Variant.presult * 10, result.presult)}
        nresultAvg={avg(over10Variant.nresult * 10, result.nresult)}
      />
    </>
  );

  const belowColumns = (
    <>
      <Variant
        {...by10Variant}
        priceLabel="* 10"
        alertClass="primary"
        colClass={colClass}
        presultAvg={avg(by10Variant.presult / 10, result.presult)}
        nresultAvg={avg(by10Variant.nresult / 10, result.nresult)}
      />
      <Variant
        {...by100Variant}
        priceLabel="* 100"
        alertClass="success"
        colClass={colClass}
        presultAvg={avg(by100Variant.presult / 10, by10Variant.presult)}
        nresultAvg={avg(by100Variant.nresult / 10, by10Variant.nresult)}
      />
    </>
  );

  const leftSideColumn = (
    <div className="col-lg-1 mb-3">
      <Average setPriceAndResultFromAvg={setPriceAndResultFromAvg} />
      <Average />
      <Average />
    </div>
  );

  const rightSideColumn = (
    <div className="col-lg-1 mb-3">
      {result.Xs?.map &&
        result.Xs.map((obj, index) => (
          <div className="form-group mb-1" key={index}>
            <label>{obj.degrees}</label>
            <input
              type="text"
              className="form-control"
              value={fmtAns(obj.price)}
              disabled
            />
          </div>
        ))}
    </div>
  );

  return (
    <>
      {!isMobile && leftSideColumn}
      {!isMobile && overColumns}
      <div className="col-lg-2 mb-3">
        <div className="mb-5">
          <div className="form-group mb-4">
            <label>Price (I5) / Low</label>
            <input
              type="number"
              className="form-control"
              step="0.01"
              id="n1"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
          <div className="form-group mb-4">
            <label>{/**Degrees */} Time (K5)</label>
            <input
              type="number"
              className="form-control"
              step="0.01"
              id="n2"
              max="900"
              min="-900"
              value={degrees}
              onChange={(e) => setDegrees(e.target.value)}
            />
          </div>
        </div>

        <Results
          alertClass={"danger"}
          colCss="col-12"
          first={result.presult}
          second={result.nresult}
          firstDifference={absoluteDifference(result.presult, price)}
          secondDifference={absoluteDifference(result.nresult, price)}
        />

        <div className="form-group mt-4">
          <label>{/**Degrees */} Find Time By Result / High</label>
          <input
            type="number"
            className="form-control mb-1"
            step="0.01"
            id="n3"
            placeholder=""
            value={xresult}
            onChange={(e) => setXresult(e.target.value)}
          />
          <button
            className="btn btn-secondary w-100"
            onClick={setDegreesFromResultAndPrice}
          >
            Find
          </button>
        </div>
      </div>
      {isMobile && overColumns}

      {belowColumns}

      {isMobile && leftSideColumn}
      {rightSideColumn}
    </>
  );
}
